import { useEffect, useState } from 'react';
import { httpV2 } from '../../http';

export const trackSearch = (event) => {
  // No raw query, record ID, labels or contact details leave this interface.
  httpV2.post('/search/events', event).catch(() => {});
};

export default function useRecordSearch(query, enabled, scope, category, page = 0) {
  const requestKey = JSON.stringify([query, enabled, scope, category, page]);
  const [state, setState] = useState({ groups: [], loading: false, error: false });
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setState({ requestKey, groups: [], loading: enabled && query.trim().length >= 2, error: false });
    if (!enabled || query.trim().length < 2) return () => { active = false; };
    const timer = setTimeout(() => {
      httpV2.post('/search', { query: query.trim(), category, page }, { signal: controller.signal }).then(({ data }) => {
        if (active) setState({ requestKey, groups: data.groups || [], loading: false, error: false });
      }).catch(() => {
        if (active && !controller.signal.aborted) setState({ requestKey, groups: [], loading: false, error: true });
      });
    }, 250);
    return () => { active = false; clearTimeout(timer); controller.abort(); };
  }, [query, enabled, scope, category, page, requestKey]);
  return state.requestKey === requestKey ? state : { groups: [], loading: enabled && query.trim().length >= 2, error: false };
}
